/*
 * Custom snap-scroll gallery for the EXODUS product page (main-product.liquid).
 *
 * Dawn's own media-gallery.js/slider-component are built around a thumbnail
 * rail that this design doesn't use, so the gallery itself is a lightweight
 * custom element here. It still exposes setActiveMedia(mediaId), the same
 * method name Dawn's VariantSelects.updateMedia() (global.js) calls on any
 * element matching [id^="MediaGallery-"] when the shopper picks a variant
 * that's linked to a specific image — that's what keeps variant-driven image
 * switching working without touching Dawn's variant-picker logic at all.
 */
(function () {
  if (customElements.get('product-gallery-exo')) return;

  customElements.define('product-gallery-exo', class ProductGalleryExo extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('[data-gallery-track]');
      this.dotsWrap = this.querySelector('[data-gallery-dots]');
      this.slides = this.track ? Array.from(this.track.children) : [];
      this.dots = this.dotsWrap ? Array.from(this.dotsWrap.children) : [];

      if (!this.track || this.slides.length === 0) return;

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.scrollToIndex(index);
        });
      });

      this.ticking = false;
      this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.ticking = false;
        var index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        this.setActiveDot(index);
        this.setActiveSlideClass(index);
      });
    }

    scrollToIndex(index) {
      var slide = this.slides[index];
      if (!slide) return;
      this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    setActiveDot(index) {
      this.dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    setActiveSlideClass(index) {
      this.slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
    }

    // Called by Dawn's variant-selects element (global.js) on variant change.
    setActiveMedia(mediaId) {
      var index = this.slides.findIndex(function (slide) {
        return slide.dataset.mediaId === mediaId;
      });
      if (index === -1) return;
      this.scrollToIndex(index);
      this.setActiveDot(index);
      this.setActiveSlideClass(index);
    }
  });
})();
